import Vue from "vue"
import Vuex from "vuex"
const fb = require("../firebaseConfig.js")

Vue.use(Vuex)

fb.auth.onAuthStateChanged(user => {
	if(user) {
		store.dispatch("fetchProfile", user)
		store.commit("setIsLoggedIn", true)
		store.commit("setLoggedInUser", user)
		//if(fb.firebase.messaging.isSupported()) store.dispatch("saveMessagingDeviceToken", user)
	}
})

export const store = new Vuex.Store({
  state: {
    pageLoading: true,
		initialized:false,
		stripeKey:{
      test:"pk_test_itCmziCcsavym8T71gROTOhj", 
      live:"pk_live_NO5i9A0rJetFGqZ99mLPeSpP"
    },
		API_URL: "https://district-conference-7030.web.app/api",
		imgPlaceholder: "https://dummyimage.com/500x500/ddd/f1f1f1&text=add-image",
		pageTitle:"Home",
		userProfile:{},
		profileDoc:"",
		userBookings:null,
		stagingCrewfinder:[],
		crewfinder:[],
		messages:[],
		isLoggedIn:false,
		loggedInUser:{},
		currentChatId:"",
		currentChat:[],
		fcmToken:"",
		confId:"",
		confName:"",
		confInfo:{},
		confList:[],
  },
  mutations: {
    setConfId(state, val) {
		state.confId = val
	},
	setConfList(state, val){
		state.confList = val
	},
	setConfName(state, val) {
		state.confName = val
	},
	setConfInfo(state, val) {
		state.confInfo = val
	},
	setUserProfile(state, val) {
		state.userProfile = val
	},
    setProfileDoc(state, val) {
		state.profileDoc = val
	},
    setUserBookings(state, val) {
		state.userBookings = val
	},
	setPageTitle(state, val){
		state.pageTitle = val
	},
	setCrewfinder(state, val){
		state.crewfinder = val
	},
	updateCrewfinderItem(state, val){
		Object.assign(state.crewfinder[val.index], val.data)
	},
	removeCrewfinderItem(state, val){
		state.crewfinder.splice(val, 1)
	},
	setStagingCrewfinder(state, val){
		state.stagingCrewfinder.unshift(val)
	},
	clearStagingCrewfinder(state){
		state.stagingCrewfinder = []
	},
	setIsLoggedIn(state, val){
		state.isLoggedIn = val
	},
	setMessages(state, val){
		state.messages = val
	},
	setCurrentChatId(state, val){
		state.currentChatId = val
	},
	setCurrentChat(state, val){
		state.currentChat = val
	},
	setLoggedInUser(state, val){
		state.loggedInUser = val
	},
	setFcmToken(state, val){
		state.fcmToken = val
	},
  },
  actions: {
    logOut(){
			fb.auth.signOut().then(()=> {
				window.location.href = "/"
			}).catch((error)=> {
				console.log(error)
			});
		},
		saveMessagingDeviceToken({dispatch}, user) {
			fb.messaging.getToken({ vapidKey: "BNvIEh59YfC-I3C4saFsuCT_uDW2UaL2bmkslWyLMO5bhy8FUjSkJfrcXTWQLzBt5fKEtZPD9_uqtrJCYDJdoIY" }).then((currentToken) => {
				if (currentToken) {
					console.log("got token")
					fb.fcmtokensCollection.doc(user.uid)
						.set({fcmToken: currentToken})
				} else {
					dispatch("requestNotificationsPermissions", user)
				}
			}).catch((error)=>{
				console.error("Unable to get messaging token.", error)
			})
			console.log("fcm")
		},
		requestNotificationsPermissions({dispatch}, user) {
			fb.messaging.requestPermission().then(()=> {
				dispatch("saveMessagingDeviceToken", user)
			}).catch((error) =>{
				console.error("Unable to get permission to notify.", error);
			});
		},
    async fetchProfile({ commit }, user){
			//Load profile
			await fb.usersCollection.where("UUID", "==", user.uid).onSnapshot((querySnapshot)=>{
				commit("setUserProfile", querySnapshot.docs[0].data())
				commit("setProfileDoc", querySnapshot.docs[0].id)	
			})
      //Load orders
			await fb.ordersCollection.where("UUID", "==", user.uid).orderBy("added", "desc").onSnapshot((querySnapshot)=>{
        let userBookings = []
        querySnapshot.forEach((doc)=>{
          userBookings = [...userBookings, {id: doc.id, data: doc.data()}]
        })
				commit("setUserBookings", userBookings)
			})
		},
		async fetchConfProfile({ commit }, confId){
			//Load conference data
			await fb.confeventsCollection.doc(confId).onSnapshot((doc)=>{
				if(doc.exists){
					commit("setConfId", confId)
					commit("setConfName", doc.data().confname)
					commit("setConfInfo", doc.data())
				}else{
					location.href = "/"
				}
			})
		},
		async fetchConfList({commit}){
			fb.confeventsCollection.where("confpublic", "==", "1").onSnapshot((querySnapshot)=>{
				let confList = []
				querySnapshot.forEach((doc)=>{
					confList = [...confList, {id: doc.id, data: doc.data()}]
				})
				commit("setConfList", confList)
			})
		},
  },
  modules: {
  }
})

store.dispatch("fetchConfList")
